import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useCallback } from 'react';
import { labelNext, labelPrevious, useDayPicker } from 'react-day-picker';

import { Button } from '@/ux-common/components/button/button';

interface CaptionWithNavProps {
  locale?: string;
}

/**
 * Custom Caption with prev/next month navigation. Uses the registry Button
 * via its CSS class API (`.btn-transparent .btn-square`).
 */
export const CaptionWithNav = ({ locale = 'en-US' }: CaptionWithNavProps) => {
  const { nextMonth, previousMonth, goToMonth, months } = useDayPicker();

  const monthCaption = months[0].date.toLocaleDateString(locale, {
    month: 'long',
    year: 'numeric',
  });
  const [monthName, year] = monthCaption.split(' ');

  const handlePrev = useCallback(() => {
    if (previousMonth) goToMonth(previousMonth);
  }, [previousMonth, goToMonth]);

  const handleNext = useCallback(() => {
    if (nextMonth) goToMonth(nextMonth);
  }, [nextMonth, goToMonth]);

  return (
    <div className="calendar-header">
      <Button
        className="btn btn-square btn-md calendar-nav-button"
        disabled={!previousMonth}
        aria-label={labelPrevious(previousMonth)}
        onClick={handlePrev}
      >
        <ChevronLeft size={24} />
      </Button>
      <span className="calendar-month-title">
        <span className="calendar-month-title-month">{monthName}</span>
        <span className="calendar-month-title-year">{year}</span>
      </span>
      <Button
        className="btn btn-square btn-md calendar-nav-button"
        disabled={!nextMonth}
        aria-label={labelNext(nextMonth)}
        onClick={handleNext}
      >
        <ChevronRight size={24} />
      </Button>
    </div>
  );
};
